import AnimatedOpacity from './animated_opacity'

export default AnimatedOpacity
